var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"back-button",on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"})])}
var staticRenderFns = []

export { render, staticRenderFns }